import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { RevealOnScroll } from "./RevealText";

const REVIEWS = [
  {
    name: "Rohan Mehta",
    trip: "Jodhpur → Udaipur",
    text: "Booked on WhatsApp in seconds. The Innova was spotless and our driver Bhanwar ji knew every good chai stop on the way. Smooth 5-hour drive!",
  },
  {
    name: "Priya Sharma",
    trip: "Airport Transfer",
    text: "Reached at 2 AM and the cab was already waiting. Fixed fare, no arguments, super polite driver. Exactly what you want after a long flight.",
  },
  {
    name: "Anil & family",
    trip: "Nakoda Ji Pilgrimage",
    text: "Took the Urbania for our group of 12. Comfortable, punctual and very fair pricing. Will only use Jodhpur Cabs from now on.",
  },
  {
    name: "Sophie Laurent",
    trip: "Jaisalmer Desert Trip",
    text: "As a solo traveller I felt completely safe. Great English-speaking driver and a beautiful desert route. Highly recommended.",
  },
];

export const Testimonials = () => {
  return (
    <section id="reviews" data-testid="testimonials-section" className="relative bg-jodhpur-bg py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
          <RevealOnScroll>
            <span className="text-xs uppercase tracking-[0.3em] text-jodhpur-accent font-semibold">Traveller Stories</span>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl text-jodhpur-primary tracking-tight max-w-xl">
              Loved by <span className="italic">thousands</span>
            </h2>
          </RevealOnScroll>
          <RevealOnScroll delay={0.1}>
            <div className="flex items-center gap-3">
              <div className="flex text-jodhpur-accent">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-current" />)}
              </div>
              <span className="text-jodhpur-ink font-semibold">4.9/5 · 2,300+ reviews</span>
            </div>
          </RevealOnScroll>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {REVIEWS.map((r, i) => (
            <motion.div
              key={r.name}
              data-testid={`review-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="relative rounded-3xl bg-white border border-jodhpur-primary/10 p-6 flex flex-col hover:shadow-[0_24px_60px_-30px_rgba(20,41,89,0.5)] transition-shadow duration-300"
            >
              <Quote className="h-8 w-8 text-jodhpur-accent/40 mb-3" />
              <p className="text-jodhpur-ink/80 leading-relaxed text-[15px] flex-1">{r.text}</p>
              <div className="mt-5 pt-5 border-t border-jodhpur-primary/10">
                <p className="font-semibold text-jodhpur-primary">{r.name}</p>
                <p className="text-sm text-jodhpur-ink/55">{r.trip}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
